import { useListFilter } from '@jetshop/core/hooks/Filters/useListFilter';
import t from '@jetshop/intl';
import {
  DropdownMenuButton as Button,
  DropdownMenuItem,
  DropdownMenuItems as Items,
} from '@jetshop/ui/DropdownMenu';
import ErrorBoundary from '@jetshop/ui/ErrorBoundary/Generic';
import PassThrough from '@jetshop/ui/ErrorBoundary/PassThrough';
import { ReactComponent as Carot } from '@jetshop/ui/svg/Carrot.svg';
import { ReactComponent as Check } from '@jetshop/ui/svg/Check.svg';
import React from 'react';
import { FakedRangeFilter } from './FakedRangeFilters';
import { FilterDropdownMenu } from './FilterDropdownMenu';
import { css } from 'linaria';
import ColorBox from '../../ui/ColorBox';
import { styled } from 'linaria/react';
import { ReactComponent as Cross } from '@jetshop/ui/svg/Cross.svg';

const InnerWrapper = styled('div')`
  display: flex;
  button {
    position: absolute;
    right: 10px;
    top: 12px;
    cursor: pointer;
    max-width: 25%;
  }
  svg {
    margin-left: 0 !important;
    path {
      fill: black;
    }
  }
`;

export function ListFilters({ filters }) {
  const listFilters = filters.filter(
    (filter) => filter.__typename === 'ListFilter'
  );

  if (listFilters.length === 0) return null;

  return listFilters.map((filter) => (
    <ErrorBoundary component={PassThrough} key={filter.id}>
      <ListFilter filter={filter} />
    </ErrorBoundary>
  ));
}

export const categoryLabelStyle = css`
  font-weight: 700;
  text-transform: capitalize;
  padding-bottom: 6px;
  border-bottom: 1px solid #b9b9b9;
  width: 100%;
  font-size: 14px;
  display: block;
  padding-left: 1.5rem;
  height: 55px;
  line-height: 55px;
`;

function ListFilter({ filter }) {
  const { apply, clear } = useListFilter({ filter });
  const onSelect = (value) => () => apply({ value });

  const useFakeRangeFilter = [
    'bredd',
    'längd',
    'diameter',
    'höjd',
    'djup',
    'sitthöjd',
    'sittdjup',
  ];

  return (
    <>
      {useFakeRangeFilter.includes(filter.name.toLowerCase()) ? (
        <FakedRangeFilter filter={filter} />
      ) : (
        <FilterDropdownMenu>
          <Button>
            <span style={{ textTransform: 'capitalize' }}>
              {filter.name.toLowerCase()}
            </span>
            {filter.hasActiveItems ? (
              <Check className={'check'} />
            ) : (
              <Carot className="carot" />
            )}
          </Button>

          <Items as="ul">
            <>
              <li className="filter-name">
                <InnerWrapper>
                  <span className={categoryLabelStyle}>
                    {filter.name.toUpperCase()}
                  </span>
                  <Button>
                    <Cross />
                  </Button>
                </InnerWrapper>
              </li>

              {filter.items.map((item, index) => (
                <DropdownMenuItem
                  key={item.id}
                  onSelect={item.resultCount > 0 && onSelect(item.value)}
                  style={
                    item.resultCount === 0
                      ? {
                          opacity: 0.4,
                          cursor: 'not-allowed',
                        }
                      : { cursor: 'pointer' }
                  }
                >
                  <ColorBox group={item.text} />
                  <span>{item.text}</span>
                  {item.isActive ? (
                    <Check />
                  ) : (
                    <span>({item.resultCount})</span>
                  )}
                </DropdownMenuItem>
              ))}
            </>
            <>
              {filter.hasActiveItems && (
                <DropdownMenuItem
                  onSelect={({ setIsOpen }) => {
                    setIsOpen(false);
                    clear();
                  }}
                >
                  {t('Clear filter')}
                </DropdownMenuItem>
              )}
            </>
          </Items>
        </FilterDropdownMenu>
      )}
    </>
  );
}
